import { render, staticRenderFns } from "./rejectReason.vue?vue&type=template&id=ae13d412&scoped=true"
import script from "./rejectReason.vue?vue&type=script&lang=js"
export * from "./rejectReason.vue?vue&type=script&lang=js"
import style0 from "./rejectReason.vue?vue&type=style&index=0&id=ae13d412&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae13d412",
  null
  
)

export default component.exports